export default {
  user: null
};
